module.exports = __webpack_public_path__ + "static/img/page_12.b36f0127.png";